import { useCrowdfundingProvider } from '../../../../Context';
import { useShowCampaignById_new } from '../../../../api';
import { CampaignStoreItemTypes } from '../../../../api/new/types/utils';

const transformUnits = (athon: CampaignStoreItemTypes) => {
  if (athon?.__type !== 'athon') return {};

  return {
    units: athon.units_of_activity,
    unitsSingular: athon.units_of_activity_singular,
    unitsPlural: athon.units_of_activity_plural,
    pluralize: (count: number) =>
      `${count} ${count === 1 ? athon?.units_of_activity : athon?.units_of_activity_plural}`,
  };
};

export const useAthonActivityUnitsQuery = ({
  causeId,
  campaignId,
}: {
  causeId: string;
  campaignId: string;
}) => {
  return useShowCampaignById_new({
    causeId,
    campaignId,
    select: transformUnits,
  });
};

/**
 * @deprecated use useAthonActivityUnitsQuery instead
 */
export const useAthonActivityUnits = () => {
  const { causeId, campaignId } = useCrowdfundingProvider();
  const { data: campaign } = useShowCampaignById_new({
    causeId,
    campaignId,
  });

  if (!campaign || campaign?.__type !== 'athon') return null;

  const athon = campaign;

  return {
    units: athon.units_of_activity,
    unitsSingular: athon.units_of_activity_singular,
    unitsPlural: athon.units_of_activity_plural,
    pluralize: (count: number) =>
      `${count} ${count === 1 ? athon?.units_of_activity : athon?.units_of_activity_plural}`,
  };
};
